<div>
    <data-table :headings="orderItemsHeadings" v-show="!loading"
                :data="orderItems"
                :hasActions="false"
                :pagingDetails="pagingDetails"
                :hasNoFilter="true">
        <template #content>
            <div class="float-right">
                <p class="permission-control" id="grandTotalParagraph"><b>Grand Total: {{grandTotal}}</b></p>
            </div>
        </template>
    </data-table>
    <loading-spinner :showSpinner="loading"></loading-spinner>
</div>